package pl.decks.personal.components.widgets.hasdiagram

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.silk.style.CssStyleVariant

class HASDiagramScope(
    val fixedNumberOuters: Int?,
) {
    internal data class HASNodeData(
        val position: HASNodePosition?,
        val variant: CssStyleVariant<HASDiagramStylesheet.Node.Kind>? = null,
        val modifier: Modifier = Modifier,
        val content: @Composable () -> Unit,
    )

    internal val nodes = mutableListOf<HASNodeData>()
    internal val resolvedNodes = mutableMapOf<HASNodePosition, HASNodeData>()

    internal val resolvedNumberOuters: Int
        get() = fixedNumberOuters ?: (
                resolvedNodes.keys
                    .mapNotNull { (it as? HASNodePosition.Outer)?.pos }
                    .maxOrNull()
                    ?.plus(1)
                    ?: 0
                )

    // null key = global default, Int key = per-spoke override
    private val lineOverrides = mutableMapOf<Int?, HASLineScope>()

    fun node(
        position: HASNodePosition? = null,
        variant: CssStyleVariant<HASDiagramStylesheet.Node.Kind>? = null,
        modifier: Modifier = Modifier,
        content: @Composable () -> Unit,
    ) {
        nodes.add(HASNodeData(position, variant, modifier, content))
    }

    fun line(
        nodePosition: Int? = null,
        lineScope: HASLineScope.() -> Unit,
    ) {
        val scope = HASLineScope().apply(lineScope)
        lineOverrides[nodePosition] = scope
    }

    internal fun resolveNodes() {
        var autoIndex = 0
        val takenIndices = nodes
            .mapNotNull { (it.position as? HASNodePosition.Outer)?.pos }
            .toSet()

        nodes.forEach { node ->
            val position = node.position ?: run {
                while (takenIndices.contains(autoIndex)) autoIndex++
                HASNodePosition.Outer(autoIndex++)
            }
            if (resolvedNodes.containsKey(position)) {
                throw HASDiagramException.DuplicateHASNodePositionException(position)
            }

            if (position is HASNodePosition.Outer && fixedNumberOuters != null && position.pos >= fixedNumberOuters) {
                throw HASDiagramException.HASNodePositionOutOfRangeException(position.pos, fixedNumberOuters)
            }
            resolvedNodes[position] = node.copy(position = position)
        }
    }

    internal fun resolvedLineFor(index: Int): HASLineScope {
        val global = lineOverrides[null] ?: HASLineScope()
        val specific = lineOverrides[index] ?: return global
        return global.merge(specific)
    }
}
